export const LIVE_PAGES_PARENT_FF = 'confluence.frontend.livepages.enable';
